import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHomeGetSectionByIdQuery } from "../../../../Services/HomeAPI";
import {  useParams } from "react-router-dom";

function AddCategory() {

  const { id } = useParams();
  const { data, isLoading: isLoadingContent, error, refetch } = useHomeGetSectionByIdQuery(id);

  console.log("data", data)
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [isTitleActive, setIsTitleActive] = useState(1);
  const [smallHeading, setSmallHeading] = useState("");
  const [isSmallHeadingActive, setIsSmallHeadingActive] = useState(1);
  const [description, setDescription] = useState("");
  const [isDescriptionActive, setIsDescriptionActive] = useState(1);
  const [productSource, setProductSource] = useState("");

  const [isActive, setIsActive] = useState(1);

  useEffect(() => {
    refetch();
  }, [refetch])


  useEffect(() => {
    setName(data?.data?.name);
    setTitle(data?.data?.title);
    setIsTitleActive(data?.data?.is_title_active ? 1 : 0);
    setSmallHeading(data?.data?.small_heading);
    setIsSmallHeadingActive(data?.data?.is_title_active ? 1 : 0);
    setDescription(data?.data?.description);
    setIsDescriptionActive(data?.data?.isDescriptionActive);
    setProductSource(data?.data?.product_source);
    setIsActive(data?.data?.is_active)
  }, [data])

 

 

  if (isLoadingContent) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>Section</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home-section-list"><span>Secion</span></Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">View</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form >
          <div className="row">
            {/* Title */}

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Title</label>
                <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
               
              </div>
            </div>

            {/* Title Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Title Active</label>
                <select className="form-control" value={isTitleActive} onChange={(e) => setIsTitleActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Small Heading */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Small Heading</label>
                <input type="text" className="form-control" value={smallHeading} onChange={(e) => setSmallHeading(e.target.value)} />
                
              </div>
            </div>

            {/* Small Heading Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Small Heading Active</label>
                <select className="form-control" value={isSmallHeadingActive} onChange={(e) => setIsSmallHeadingActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Description */}
            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Description</label>
                <textarea className="form-control" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                
              </div>
            </div>

            {/* Description Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Description Active</label>
                <select className="form-control" value={isDescriptionActive} onChange={(e) => setIsDescriptionActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>

            {/* Product Source */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Product Source</label>
                <select className="form-control" value={productSource} onChange={(e) => setProductSource(e.target.value)}>
                  <option value="">Select Product source</option>
                  <option value="featured">Featured</option>
                  <option value="best_seller">Best Seller</option>
                  <option value="top_rated">Top Rated</option>
                  <option value="new_arrivals">New Arrivals</option>
                  <option value="category">Category</option>
                  <option value="featured_category">Featured Category</option>
                </select>
                
              </div>
            </div>


            {/* Is Active */}
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Is Active</label>
                <select className="form-control" value={isActive} onChange={(e) => setIsActive(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
          </div>
       
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
